import React from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import CustomForm from "../../../../common/components/CustomForm";

import { styles } from "./SensorForm.styles";
import { formFields, formSchema } from "./SensorForm.schema";

import { selectError, addSensor, updateSensor, selectLoader } from "../../structureSlice";

function SensorForm({ classes, selectedProject, payload, onSubmit }) {
  const { t } = useTranslation();
  const error = useSelector(selectError);
  const loader = useSelector(selectLoader);
  const dispatch = useDispatch();

  const onSubmitHandler = async (values) => {
    console.log("values: %o", values);
    if (!values.id) {
      dispatch(addSensor(selectedProject, values));
    } else {
      dispatch(updateSensor(selectedProject, values));
    }
    onSubmit && onSubmit();
  };

  return (
    <Grid className={classes.root} container direction="row" justify="center" alignItems="center">
      <div>
        <CustomForm
          payload={payload}
          schema={formSchema(t)}
          fields={(values) => formFields(t, values)}
          error={error}
          submitLabel={"Submit"}
          onSubmit={onSubmitHandler}
          submitting={Boolean(loader)}
        />
      </div>
    </Grid>
  );
}

export default withStyles(styles)(SensorForm);
